import React from 'react';
// import { MenuBtn } from '../components/MenuBtn';
import AboutImg from '../images/PageImg/about-img.jpg';
import ContactImg from '../images/PageImg/contact-img.jpg';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { ContactInfo } from '../components/ContactInfo';
import { CompanySlider } from '../components/CompanySlider'
import { ProcessFlow } from '../components/ProcessFlow'
import { HlzTeams } from '../components/HlzTeams'
import { HlzWorks } from '../components/HlzWorks'
import { Footer } from '../components/Footer';
import './Home.css';

export default function Home() {
  console.log("into Home()");
  return (
    <div className='home-page'>
      {/* <header className='h-100 min-vh-100 d-flex align-items-center text-light shadow'> */}
      {/* <header className='col-lg-12 d-flex align-items-center text-light'> */}
      {/* < companySlider /> */}
      {/* </header> */}
      <header className='vh-80 align-items-center text-light shadow'> <CompanySlider /> </header>
      <div className='my-5'>
        <Row>
          {/* <Row className='row'> */}
          <Col lg={6} className='justify-content-center d-lg-flex'>
            {/* <Col lg={6} className='d-flex justify-content-center d-none d-lg-flex'> */}
            <img style={{ height: '60vh' }} src={AboutImg} className='img-fluid' alt="PageImg/about-img.jpg" />
          </Col>
          {/* <div className='col-lg-6 d-flex flex-column align-items-center justify-content-center'> */}
          <Col lg={6} className='d-flex flex-column justify-content-center'>
            <h1 className='mb-3 fw-bold text-center'>关于合利资光电科技</h1>
            <h2 className='mb-3 fw-bold text-center'>东莞市合利资光电科技有限公司，成立于2013年</h2>
            <h2 className='mb-3 fw-bold text-center'>对于触摸屏的研发，生产，销售拥有丰富的经验</h2>
            <h2 className='mb-3 fw-bold text-center'>工厂集成了2.4寸至65寸功能片，TP，光学贴合配套的完整生产线</h2>
            <h2 className='mb-3 fw-bold text-center'>产品远销海内外，并可依照您的产品应用提供客制化的服务</h2>
            <h2 className='mb-3 fw-bold text-center'>应用于工业控制，医疗，智能家居，航空航天，教育，POS零售，交通运输等领域</h2>
            <h2 className='mb-3 fw-bold text-center'>我们致力于打造成一流的触摸屏制造商，以满足客户的多样化需求。</h2>
            <br/>
            {/* <p className='mb-0 fs-4'>　　　2013年 2013年7月公司成立深圳市合利资科技有限公司</p> */}
            {/* <p className='mb-0 fs-4'>　　　2015年 增加车机类</p> */}
            {/* <p className='mb-1 fs-4'>　　　2016年 新址投入, 无尘车间提高至千级, 增加32~85"制程</p> */}
            {/* <p className='mb-1 fs-4'>　　　2017年 新增加大尺寸生产线一条</p> */}
            {/* <p className='mb-1 fs-4'>　　　2018年 公司转型, 产品差异化(工控/医疗/一体机/军工等)</p> */}
            {/* <p className='mb-1 fs-4'>　　　2019年 丝印增至3条线绑定增至3条线</p> */}
            {/* <p className='mb-1 fs-4'>　　　2020年 厂房再次扩张及升级</p> */}
            {/* <p className='mb-1 fs-4'>　　　2021年 设立TP贴合线</p> */}
            {/* <p className='mb-1 fs-4'>　　　2022年 设立OCA全贴合线</p> */}
            {/* <p className='mb-1 fs-4'>　　　2023年 设立厚胶全贴合线</p> */}
            <Link to="/AboutUs" className='d-flex justify-content-center'>
              <button className='btn btn-success btn-lg fs-4'>More About Us</button>
              {/* <button className='btn btn-success btn-outline-success btn-lg'>More About Us</button> */}
            </Link>
          </Col>
        </Row>
      </div>

      <div> < ProcessFlow /> </div>
      <div> < HlzTeams /> </div>
      <div> < HlzWorks /> </div>

      <div className='bg-dark text-light py-5 shadow'>
        <Container>
          {/* <div className='container'> */}
          <Row>
            {/* <div className='row'> */}
            <Col lg={6} className='d-flex flex-column align-items-center justify-content-center mb-lg-0'>
              <ContactInfo />
            </Col>
            <Col lg={6} className='d-flex justify-content-center'>
              <img src={ContactImg} className='img-fluid w-60' alt="PageImg/contact-img.jpg" />
            </Col>
          </Row>
        </Container>
      </div>
      <footer id='footer'><Footer /></footer>
      {/* <div> < Footer /> </div> */}
    </div>
  )
}

// export default Home;